export default __webpack_public_path__ + "static/media/2.c9cbb5b1.svg";